import { doc, getDoc } from 'firebase/firestore'
import { auth, db } from '@/lib/firebase'

/**
 * Authoritative web-access check (mobile-only billing MVP).
 *
 * Liverly has no web checkout — subscriptions are bought in the mobile app via
 * RevenueCat, which writes `isPremium` onto lb_users/{uid} (PaywallContext on
 * purchase + entitlement refresh on launch). The web app trusts that flag for
 * UI gating only; every paid cloud function independently verifies the LIVE
 * RevenueCat entitlement server-side (Critical Rule: premium is enforced on
 * both ends), so a hand-edited flag unlocks nothing that matters.
 *
 * A fresh one-shot read (not the cached real-time mirror) so "Already
 * subscribed? Refresh" on the gate reflects a just-finished mobile purchase.
 */
export async function fetchWebAccess(): Promise<boolean> {
  const uid = auth.currentUser?.uid
  if (!uid) return false
  const snap = await getDoc(doc(db, 'lb_users', uid))
  return snap.exists() && snap.data()?.isPremium === true
}
